import React, { useState } from 'react'
import ModalTest from '../../BaseModal'
import * as S from '../../styles/modal-style'
import { Plus, X } from 'lucide-react'
import axios from '../../../config/axios'
import styled from 'styled-components'

interface CreatePipelineModalProps {
  closeModal: () => void
  newPipeline: React.Dispatch<React.SetStateAction<{id: number, name: string}[]>>
}

const CreatePipelineModal = ({ closeModal, newPipeline }: CreatePipelineModalProps) => {
  const [ formData, setFormData ] = useState({
    name: '',
    steps: ''
  })

  const handleCreatePipeline = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/pipelines/pipeline`, formData)
      if(response.data) {
        newPipeline(prev => ([
          ...prev,
          response.data.data
        ]))
        closeModal()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <ModalTest>
      <S.ContainerOfModal width='900px'>
        <S.Header>
          <S.HeaderTitle>Criar funil</S.HeaderTitle>
          <S.CloseDiv onClick={() => closeModal()}>
            <X size={20} />
          </S.CloseDiv>
        </S.Header>
        <S.FormContainer>
          <S.InputDiv>
            <S.Label>Nome do funil</S.Label>
            <S.Input type='text' placeholder='Digite aqui' value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} />
          </S.InputDiv>
          <S.InputDiv>
            <S.Label>Etapas</S.Label>
            <S.Input type='text' placeholder='Digite aqui' value={formData.steps} onChange={(e) => setFormData({...formData, steps: e.target.value})} />
          </S.InputDiv>
        </S.FormContainer>
        <S.BottomDiv>
          <S.ButtonContainer>
            <S.Button className='cancel' onClick={() => closeModal()}>Cancelar</S.Button>
            <S.Button onClick={() => handleCreatePipeline()}><Plus /> Criar funil</S.Button>
          </S.ButtonContainer>
        </S.BottomDiv>
      </S.ContainerOfModal>
    </ModalTest>
  )
}

export default CreatePipelineModal